// Login e o estado "aguardando aprovação".
//
// Todo usuário novo nasce com active = false (trigger on_auth_user_created, na
// migration 001). Entrar com Google não dá acesso a nada até alguém da gestão
// aprovar. Esta tela existe para que isso não pareça um erro do sistema.

import { getSupabase } from '../../lib/supabase';
import { esc } from '../../lib/format';
import type { SessaoUsuario } from '../../lib/permissions';

function tela(html: string): void {
  const app = document.getElementById('app');
  if (app) app.innerHTML = html;
}

export function mostrarLogin(erro?: string): void {
  tela(`
    <div class="auth">
      <div class="auth-cartao">
        <div class="auth-marca">
          <strong>Clean Dental</strong>
          <span>CD Painel</span>
        </div>
        <p class="auth-texto">Entre com a conta da clínica para continuar.</p>
        ${erro ? `<div class="auth-erro">${esc(erro)}</div>` : ''}
        <button id="entrar-google" class="botao-principal">Entrar com Google</button>
        <form id="form-email" class="auth-form">
          <label for="email">ou entre com e-mail e senha</label>
          <input id="email" type="email" autocomplete="username" placeholder="e-mail" required />
          <input id="senha" type="password" autocomplete="current-password" placeholder="senha" required />
          <button type="submit" class="botao-secundario">Entrar</button>
        </form>
      </div>
    </div>`);

  document.getElementById('entrar-google')?.addEventListener('click', () => {
    void getSupabase().auth.signInWithOAuth({
      provider: 'google',
      options: { redirectTo: location.origin },
    });
  });

  document.getElementById('form-email')?.addEventListener('submit', (ev) => {
    ev.preventDefault();
    const email = (document.getElementById('email') as HTMLInputElement | null)?.value ?? '';
    const senha = (document.getElementById('senha') as HTMLInputElement | null)?.value ?? '';
    void (async () => {
      const { error } = await getSupabase().auth.signInWithPassword({ email, password: senha });
      if (error) {
        mostrarLogin('E-mail ou senha incorretos.');
        return;
      }
      location.reload();
    })();
  });
}

export function mostrarAguardandoAprovacao(sessao: SessaoUsuario): void {
  tela(`
    <div class="auth">
      <div class="auth-cartao">
        <div class="auth-marca">
          <strong>Clean Dental</strong>
          <span>CD Painel</span>
        </div>
        <h1 class="auth-titulo">Aguardando aprovação</h1>
        <p class="auth-texto">
          Sua conta foi criada com <strong>${esc(sessao.email ?? '')}</strong>, mas ainda
          precisa ser liberada por alguém da gestão. Assim que isso acontecer,
          basta entrar de novo.
        </p>
        <button id="sair" class="botao-secundario">Sair</button>
      </div>
    </div>`);

  document.getElementById('sair')?.addEventListener('click', () => {
    void (async () => {
      await getSupabase().auth.signOut();
      location.reload();
    })();
  });
}
